import * as React from 'react'
import './ToolsPage.css'
import ToolsConnector from './ToolsConnector'
import { IConnector } from './connectors'
import { ToolsHeaderSvg } from './ToolsHeaderSvg'

export type ValueProps = {
  sourceConnectors: IConnector[]
  destinationConnectors: IConnector[]
}

export type EventProps = {}

export type Props = ValueProps & EventProps

export class ToolsPage extends React.Component<Props> {
  
  render() {
    const {sourceConnectors, destinationConnectors} = this.props
    
    return (
      <div className={'tools-page-container'}>
        <div className={'tools-page-header'}>
          <div className={'tools-page-header-title'} data-test-id="tools-page-header-title">
            <ToolsHeaderSvg/>
          </div>
          <div className={'tools-page-header-subtitle'} data-test-id="tools-page-header-subtitle">
            <span>
              Build simple integrations with Mule to automatically deliver Anypoint Monitoring notifications into the right external systems
            </span>
          </div>
        </div>
        <div className={'tools-body-container'}>
          <div className={'tools-connectors-row'}>
            <span className={'tools-category-title'} data-test-id="tools-header-source-connectors">Source Connectors</span>
            <div className={'tools-connectors-container'} data-test-id="tools-connectors-container-source">
              {
                sourceConnectors.map((connector, index) => {
                  return (
                    <ToolsConnector
                      key={index}
                      title={connector.title}
                      description={connector.description}
                      link={connector.link}
                      type={connector.type}
                    />
                  )
                })
              }
            </div>
          </div>
          <div className={'tools-connectors-row'}>
            <span className={'tools-category-title'} data-test-id="tools-header-destination-connectors">Destination Connectors</span>
            <div className={'tools-connectors-container'} data-test-id="tools-connectors-container-destination">
              {
                destinationConnectors.map((connector, index) => {
                  return (
                    <ToolsConnector
                      key={index}
                      title={connector.title}
                      description={connector.description}
                      link={connector.link}
                      type={connector.type}
                    />
                  )
                })
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}